var map = {
	"./Gilroy-Bold.woff2": 403,
	"./Gilroy-Medium.woff2": 404,
	"./Gilroy-Regular.woff2": 255,
	"./Gilroy-SemiBold.woff2": 405,
	"./NarrateIcons.woff2": 406
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 402;